﻿window.cObjetArtgroupeMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "groupe article"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau groupe article"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined' && objet.data.nom != null && objet.data.nom.length > 0) { txt = objet.data.nom }
        else {
            txt = "..."
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-barcode'></i>");
    }

    this.mGetMaxTri = function () {
        var nb = 0
        Me.objet.bddRef.mGetArray("artgroupe").forEach(function (artgroupe) {
            if (nb < parseInt(artgroupe.tri)) nb = parseInt(artgroupe.tri)
        })
        return nb
    }

    this.mCreateNewArtgroupe = function (newNom,funcOk) {
        var newData = objet.mGetNewData()
        newData.nom = newNom
        newData.tri = this.mGetMaxTri() + 1
        Me.objet.bddRef.getObjet(newData).mSave(function (data) {
            funcOk(newData)
        })
    }

    this.mGetLstArticle = function () {
        var lstGrpArticle = Me.objet.bddRef.mGetArray("artgroupe_article").filter(function (artGrpArticle) {
            return artGrpArticle.id_artgroupe == itemData.data.id_artgroupe
        }).sort(function (o1, o2) { return o1.tri - o2.tri })
        lstArticle = Me.objet.bddRef.mGetArray("article").filter(function (article) {
            return lstGrpArticle.filter(function (artGroupeArticle) { artGroupeArticle.id_article == article.id_article }).length > 0
        })
        return lstArticle
    }

}